import { render, staticRenderFns } from "./APIKey.vue?vue&type=template&id=53add03c&scoped=true&"
import script from "./APIKey.vue?vue&type=script&setup=true&lang=js&"
export * from "./APIKey.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./APIKey.vue?vue&type=style&index=0&id=53add03c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53add03c",
  null
  
)

export default component.exports